// extracted by mini-css-extract-plugin
export default {"container":"_2Jk2y-Dmc_eqBQ1x6BFbO0"};